import Video from "@/components/video";
import { PreheatInfo } from "@/pages/live/types/types";
import { getPlatform } from "@/utils/platform";
import React, { useCallback, useState } from "react";
import styles from "./index.module.scss";

const { isWxH5 } = getPlatform();

interface CoverProps {
  preheatInfo: PreheatInfo;
}

const Cover: React.FC<CoverProps> = ({ preheatInfo }) => {
  const [controlsAble, setControlsAble] = useState(false);

  // 视频开始播放
  const handleVideoPlay = useCallback(() => {
    setControlsAble(true);
  }, []);

  // 视频结束播放
  const handleVideoEnded = useCallback(() => {
    setControlsAble(false);
  }, []);

  return (
    <div className={styles.cover} style={{ backgroundImage: `url(${preheatInfo.coverUrl})` }}>
      {preheatInfo.propagandaVideoUrl && isWxH5 && (
        <div className={styles.videoBox}>
          <Video
            src={preheatInfo.propagandaVideoUrl}
            poster={preheatInfo.propagandaVideoCoverUrl}
            controls={controlsAble}
            style={{ width: "100%", height: "auto" }}
            onPlay={handleVideoPlay}
            // onPause={handleVideoPause}
            onEnded={handleVideoEnded}
          />
        </div>
      )}
    </div>
  );
};

export default Cover;
